var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('vpd-toolbar'),_c('main',{staticClass:"app-main"},[_c('router-view')],1),_c('vpd-cookie-banner',{attrs:{"showBanner":_vm.show},on:{"hideCookieBanner":_vm.hideCookieBanner}}),_c('vpd-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }